module.exports = __webpack_public_path__ + "img/img_quienes_somos.9aaed140.webp";